import React from "react";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import { SwipeableDrawer, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import Img from "../Images/synccare.png";
import MenuItems from "./MenuItems";

const drawerWidth = 320;

const openedMixin = (theme) => ({
  width: drawerWidth,
  backgroundColor: theme.palette.primary.dark,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: "0px",
  backgroundColor: theme.palette.primary.dark,
});

const DrawerHeader = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  marginLeft: "20px",
  ...theme.mixins.toolbar,
  "& img": {
    width: "200px",
    marginTop: "7px",
  },
  "& a": {
    textDecoration: "none",
    color: theme.palette.primary.light,
    display: "flex",
    alignItems: "center",
  },
  "& h3": {
    letterSpacing: "1px",
    fontSize: "25px",
    margin: "0",
  },
  "& small": {
    fontSize: "13px",
    position: "relative",
    top: "10px",
    left: "-3px",
  },
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  backgroundColor: theme.palette.primary.dark,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const Swipeable = styled(SwipeableDrawer)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export default function DrawerContent({
  open,
  mobileOpen,
  screenWidth,
  menuList,
  isStaticRoute,
  onMobileDrawerOpen,
  onMobileDrawerClose,
}) {
  const drawerContent = (
    <>
      <DrawerHeader>
        <Link to="/">
          <img src={Img} alt="synccare_logo" />
        </Link>
      </DrawerHeader>
      <Divider />
      <MenuItems
        menuList={menuList}
        isStaticRoute={isStaticRoute}
        open={open}
      />
    </>
  );

  if (screenWidth > 768) {
    return (
      <Drawer open={open} variant="permanent">
        {drawerContent}
      </Drawer>
    );
  }

  return (
    <Swipeable
      anchor="left"
      open={mobileOpen}
      onOpen={onMobileDrawerOpen}
      onClose={onMobileDrawerClose}
    >
      {drawerContent}
    </Swipeable>
  );
}
